import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable()
export class UserSettingStorageService {
  private readonly SETTINGS_KEY: string = 'USER_SETTINGS';

  constructor(private readonly storageService: StorageService) {}

  async fetchSettings(): Promise<Record<string, string>> {
    try {
      const settings = await this.storageService.fetch(localStorage, this.SETTINGS_KEY);
      return settings ? JSON.parse(settings) : {};
    } catch (error) {
      console.error('Failed to parse user settings:', error);
      return {};
    }
  }

  updateSettings(settingsObj: Record<string, string>): void {
    const updatedSettings = JSON.stringify(settingsObj);
    this.storageService.store(localStorage, this.SETTINGS_KEY, updatedSettings);
  }

  async delete(key: string): Promise<Record<string, string>> {
    const currentSettings = await this.fetchSettings();
    if (key in currentSettings) {
      delete currentSettings[key];
      this.updateSettings(currentSettings);
    }
    return currentSettings;
  }

  deleteSettings(): void {
    this.storageService.delete(localStorage, this.SETTINGS_KEY);
  }

  async fetch(key: string): Promise<string | undefined> {
    if (!key) {
      throw new Error('Missing Key');
    }
    const currentSettings = await this.fetchSettings();
    return currentSettings[key];
  }

  async store(key: string, data: string): Promise<Record<string, string>> {
    if (data == null || key == null) {
      throw new Error('Missing Key/Value pair definition');
    }
    const currentSettings = await this.fetchSettings();
    currentSettings[key] = data;
    this.updateSettings(currentSettings);
    return currentSettings;
  }
}
